const useUrlQuery = name => {
  let params = new URLSearchParams(document.location.search);
  return params.get(name);
};

export default useUrlQuery;
